import React from 'react';

const GitBashIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="70"
            height="70"
            viewBox="31.983 32.285 135.545 132.495"
        >
            <path
                fill="#ff8080"
                d="M95.72 81.45V94L65.61 63.9l10-10L90.8 69.1a9.75 9.75 0 00-.61 3.43 9.91 9.91 0 005.53 8.92zm9.23 1.81l4.68 4.68-4.68 4.69zM133.59 64L115.5 82.07 109.41 76a9.83 9.83 0 00.54-4.67 10 10 0 00-9.39-8.68 9.64 9.64 0 00-3.89.6L81.47 48l12.88-12.84a7.36 7.36 0 0110.42 0z"
            ></path>
            <path
                fill="#80b3ff"
                d="M89.74 105.53l-27.36 27.36L35.23 106a8.49 8.49 0 01.09-11.86l28-28 26.42 26.51a9.12 9.12 0 010 12.88z"
            ></path>
            <path
                fill="#ffe680"
                d="M105 108.79v11.49a9.46 9.46 0 014.46 9.88 9.32 9.32 0 01-7.42 7.53A9.47 9.47 0 0195.72 120v-12.7a1 1 0 00-1.63-.68l-28.67 28.66 29.5 29.5a7.33 7.33 0 0010.36 0L133.11 137z"
            ></path>
            <path
                fill="#8dd35f"
                d="M163.54 107.45L137 134l-28.58-28.58a8.56 8.56 0 010-12.1l3.29-3.32 7.29 7.27a9.92 9.92 0 105.88-5.88l-7.25-7.24 18.54-18.53L163.54 93a10.19 10.19 0 010 14.45z"
            ></path>
        </svg>
    );
};

export default GitBashIcon;